import routes from "./routes";

export default {
  install(Vue, { router }) {
    router.addRoutes(routes);
  }
};
